import React from 'react';

import CriteoDataLayerReporter from 'ggApp/modules/criteo/components/criteoDataLayerReporter';
import criteoEventType from 'ggApp/modules/criteo/eventTypes';
import { translate } from 'ggApp/modules/translator/selectors';

import SchemeMarkupOrganizationContainer from 'ggApp/shared/containers/SchemeMarkupOrganizationContainer';
import AlternateLocaleLinkContainer from 'ggApp/shared/containers/AlternateLocaleLink';
import CanonicalLinkContainer from 'ggApp/shared/containers/CanonicalLink';
import MetaTagsContainer from 'ggApp/shared/containers/metaTags';
import ForYouPage from 'ggApp/shared/components/ForYou';

export default class Home extends React.PureComponent {
    render() {
        const {
            widgetList,
            productImpressionCallbacks,
            categoryList,
            translations,
            storeActive: { activeLanguage },
            homePageContent,
            widgetListProducts,
        } = this.props;
        const metaPageInfo = {
            title: translate(translations, activeLanguage, 'METAINFO_HOME_TITLE'),
            description: translate(translations, activeLanguage, 'METAINFO_HOME_DESCRIPTION'),
            keywords: null,
        };

        return (
            <ForYouPage
                widgetList={widgetList}
                productImpressionCallbacks={productImpressionCallbacks}
                categoryList={categoryList}
                homePageContent={homePageContent}
                widgetListProducts={widgetListProducts}
            >
                <AlternateLocaleLinkContainer />
                <CanonicalLinkContainer />
                <SchemeMarkupOrganizationContainer />
                <MetaTagsContainer metaTags={metaPageInfo} />
                <CriteoDataLayerReporter type={criteoEventType.homePage} />
            </ForYouPage>
        );
    }
}
